import { Lightbulb } from "lucide-react";

export default function CoachBanner({ message, className = "" }) {
  if (!message) return null;
  return (
    <div
      className={[
        "glass rounded-lg p-3 sm:p-4 mb-3 border border-[color:var(--primary)]/35 bg-[color:var(--primary)]/8",
        "flex gap-3 items-start text-sm",
        className,
      ].join(" ")}
      data-testid="coach-banner"
      role="status"
    >
      <Lightbulb size={18} className="text-[color:var(--primary)] shrink-0 mt-0.5" />
      <p className="text-[color:var(--text-primary)] leading-relaxed">{message}</p>
    </div>
  );
}
